export default {
  name: 'RealNameGuide',
  components: {}
};